// modules
import React from 'react';
import {
  Route,
  Redirect,
  RouteComponentProps,
  withRouter,
} from 'react-router-dom';
import queryString from 'query-string';

// logic
import { useStore } from '../../store';

interface IProtectedRoute extends RouteComponentProps {
  component: React.FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
}

const ProtectedRoute: React.FC<IProtectedRoute> = ({
  component: Component,
  ...rest
}) => {
  const { user, userDataLoaded } = useStore((state) => ({
    user: state.user,
    userDataLoaded: state.userDataLoaded,
  }));

  /**
   * Old links (e.g. security notification emails) point at `/?appId=<id>`.
   */
  const { appId } = queryString.parse(rest.location.search);
  if (typeof appId === 'string' && appId) {
    return <Redirect to={`/apps/${appId}`} />;
  }

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        // Don't redirect until we've checked auth status
        if (!userDataLoaded) {
          return null;
        }
        return user ? (
          <Component {...routeProps} />
        ) : (
          <Redirect
            to={`/login?redirectTo=${window.location.pathname}${window.location.search}`}
          />
        );
      }}
    />
  );
};

export default withRouter(ProtectedRoute);
